export default __webpack_public_path__ + "static/media/1.47040555.png";